<template>
  <div>
    <!-- banner -->
    <div class="home_banner">
      <div class="home-slider-banner owl-carousel owl-theme">
        <div class="single-slider">
          <a href="/About" class="banner-link">
            <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901711_1-(1).jpg" alt="banner0" />
          </a>
          <div class="container text-center">
            <div class="content overflow animated">
              <h3 class="intro animated">
                {{ $t("index.imgTtile1") }}
              </h3>
              <div class="banner-more-button animated">
                <router-link class="text-capitalize default-link" to="/About">{{ $t("index.btnText1") }}→</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="single-slider">
          <a href="/About" class="banner-link">
            <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901723_1-(2).jpg" alt="banner1" />
          </a>
          <div class="container text-center">
            <div class="content overflow animated">
              <h3 class="intro animated">
                {{ $t("index.imgTtile2") }}
              </h3>
              <div class="banner-more-button animated">
                <router-link class="text-capitalize default-link" to="/About">{{ $t("index.btnText1") }}→</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="single-slider">
          <a hrefs="/About" class="banner-link">
            <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901729_1-(3).jpg" alt="banner2" />
          </a>
          <div class="container text-center">
            <div class="content overflow animated">
              <h3 class="intro animated">
                {{ $t("index.imgTtile3") }}
              </h3>
              <div class="banner-more-button animated">
                <router-link class="text-capitalize default-link" to="/About">{{ $t("index.btnText1") }}→</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="index-banner-bottom-part overflow d-flex" style="background-color: #000">
      <div class="col-md-4 col-sm-4 col-xs-12 text-center" style="padding: 0">
        <div class="item lazy bg-cover" data-original="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668087865_1.jpg">
          <div class="banner-icon wow fadeInUp" style="position: relative; z-index: 4">
            <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667898891_1.png" :alt="$t('index.bannerBottomPart1Title')" />
          </div>
          <div class="main-title wow fadeInUp">{{ $t("index.bannerBottomPart1Title") }}</div>
          <div class="banner-bottom-desc wow fadeInUp">
            {{ $t("index.bannerBottomPart1Content") }}
          </div>
          <div class="hover-bg trans-dot5s lazy" data-original="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668087770_02.jpg"></div>
        </div>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-12 text-center" style="padding: 0">
        <div class="item lazy bg-cover" data-original="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667553719_3.jpg">
          <div class="banner-icon wow fadeInUp" style="position: relative; z-index: 4">
            <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668237973_22.png" :alt="$t('index.bannerBottomPart2Title')" />
          </div>
          <div class="main-title wow fadeInUp">{{ $t("index.bannerBottomPart2Title") }}</div>
          <div class="banner-bottom-desc wow fadeInUp">
            {{ $t("index.bannerBottomPart2Content") }}
          </div>
          <div class="hover-bg trans-dot5s lazy" data-original="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668087770_02.jpg"></div>
        </div>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-12 text-center" style="padding: 0">
        <div class="item lazy bg-cover" data-original="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1666601099_banner_bottom_bg1.jpg">
          <div class="banner-icon wow fadeInUp" style="position: relative; z-index: 4">
            <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668237958_33.png" :alt="$t('index.bannerBottomPart3Title')" />
          </div>
          <div class="main-title wow fadeInUp">{{ $t("index.bannerBottomPart3Title") }}</div>
          <div class="banner-bottom-desc wow fadeInUp">
            {{ $t("index.bannerBottomPart3Content") }}
          </div>
          <div class="hover-bg trans-dot5s lazy" data-original="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668087770_02.jpg"></div>
        </div>
      </div>
    </section>

    <!-- About -->
    <section class="index-about-part overflow">
      <div class="container clearfix d-flex align-items-center">
        <div class="about-left">
          <div class="company-ibox relative">
            <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668150177_1.webp" alt="About Us" style="width: 100%" />
            <a href="https://www.youtube.com/watch?v=xX9MpyGdSmw" data-fancybox="video" class="video-link"></a>
          </div>
        </div>
        <div class="about-right">
          <h2 class="home-main-title wow fadeInUp">
            {{ $t("index.abTItle") }}
          </h2>
          <div class="about-sub-title wow fadeInUp">
            {{ $t("index.abSubTile") }}
          </div>
          <div class="about-desc wow fadeInUp">
            <p>
              {{ $t("index.abContent") }}
            </p>
          </div>
          <div class="default-link-box fontSize wow fadeInUp">
            <router-link class="default-link text-capitalize" to="/About">{{ $t("index.btnText1") }}→</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Factory environment displays -->
    <section class="index-case-part overflow">
      <div class="container">
        <h2 class="home-main-title wow fadeInUp text-center white">
          {{ $t("index.faTtile") }}
        </h2>
        <div class="home-sub-title relative wow fadeInUp text-center text-capitalize">
          <i class="title-line title-line1"></i>
          <span>{{ $t("index.faSubTtile") }}</span>
          <i class="title-line title-line2"></i>
        </div>
        <div class="case-sub-desc">
          {{ $t("index.faContent") }}
        </div>
      </div>

      <div class="case-carousel owl-carousel index-carousel owl-theme">
        <div class="case-item" v-for="(item, index) in 15" :key="index">
          <div class="case-img">
            <img :src="info[`fimg${item}`]" :alt="$t(`index.ft${item}`)" />
          </div>
          <div class="case-info d-flex justify-content-between align-items-center">
            <div class="case-info-left">
              <div class="case-title clamp">{{ $t(`index.ft${item}`) }}</div>
            </div>
            <div class="case-info-right hidden-sm hidden-xs">
              <router-link class="text-capitalize default-link" to="/Factory">{{ $t("index.btnText1") }}→</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- products -->
    <section class="index-products-part overflow lazy" data-original="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668498958_2(2).jpg">
      <div class="container">
        <h2 class="home-main-title wow fadeInUp text-center">
          {{ $t("index.oemTtile") }}
        </h2>
        <div class="home-sub-title relative wow fadeInUp text-center text-capitalize">
          <i class="title-line title-line1"></i>
          <span>{{ $t("index.oemSubTtile") }}</span>
          <i class="title-line title-line2"></i>
        </div>
        <ul class="filter-tabs wow fadeInUp text-center fontSize">
          <li class="filter" :class="{ active: info.type == '' }" @click="typeChange('')">
            {{ $t("index.oemList1") }}
          </li>
          <li class="filter" :class="{ active: info.type == 1 }" @click="typeChange(1)">
            {{ $t("index.oemList2") }}
          </li>
          <li class="filter" :class="{ active: info.type == 2 }" @click="typeChange(2)">
            {{ $t("index.oemList3") }}
          </li>
          <li class="filter" :class="{ active: info.type == 3 }" @click="typeChange(3)">
            {{ $t("index.oemList4") }}
          </li>
          <li class="filter" :class="{ active: info.type == 4 }" @click="typeChange(4)">
            {{ $t("index.oemList5") }}
          </li>
        </ul>
        <div v-if="loading" style="text-align: center;">Loading...</div>
        <div class="filter-list">
          <div class="filter-ibox active-tab">
            <div v-if="!loading" class="product-carousel1 owl-carousel index-carousel owl-theme">
              <div class="product-block-item" v-for="(item, index) in info.list" :key="index" @click="toDetail(item)">
                <a hrefs="" :title="item.productName" class="product-img img-block">
                  <img :src="item.cover" :alt="item.productName" />
                </a>
                <a class="product-title text-center" hrefs="" :title="item.productName">{{ item.productName }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ODM / OEM Service -->
    <section class="index-service-part overflow">
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-sm-12 col-xs-12 left hidden-sm hidden-xs">
            <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668388519_1.png" alt="Full Custom Ebike Within Your  Budget" />
          </div>
          <div class="col-md-7 col-sm-12 col-xs-12">
            <h2 class="home-main-title wow fadeInUp">
              {{ $t("index.odTitle") }}
            </h2>
            <div class="service-text wow fadeInUp" v-html="$t('index.odContent')"></div>
            <div class="service-list row">
              <div class="col-md-6 col-sm-6 col-xs-12 d-flex align-items-center service-item wow fadeInUp" v-for="(item, index) in [$t('index.odConList1'), $t('index.odConList2'), $t('index.odConList3'), $t('index.odConList4')]" :key="index">
                <div class="service-icon">
                  <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668238371_1-(1).png" :alt="item" />
                </div>
                <div class="service-title1">
                  {{ item }}
                </div>
              </div>
            </div>

            <router-link class="service-more trans-dot5s" to="/Services">{{ $t("index.odBtn") }}→</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Inquiry Form -->
    <section class="index-inquiry-part overflow">
      <div class="container">
        <div class="relative">
          <div class="contact-type-ibox overflow lazy" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667531465_contact_bg.png">
            <h2 class="inquiry-main-title wow fadeInUp white">
              {{ $t("index.formTtile") }}
            </h2>
            <div class="contact-item">
              <i class="fa fa-envelope" aria-hidden="true"></i>
              <a href="mailto:info@midonkey.com">info@midonkey.com</a>
            </div>
            <div class="contact-item">
              <i class="fa fa-phone" aria-hidden="true"></i>
              <a href="tel:008676982827404">0086-769-82827404</a>
            </div>
            <div class="contact-item">
              <i class="fa fa-phone" aria-hidden="true"></i>
              <a href="tel:008615817481923">0086-15817481923</a>
            </div>
            <div class="social_list fontSize">
              <a href="skype:eyketang?call" target="_blank"> <img class="lazy" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667531530_icon1.png" target="_blank" alt="img" style="vertical-align: -12px" />Skype </a>

              <a href="https://api.whatsapp.com/send?phone=+8615817481923&text=Hello" target="_blank"> <img class="lazy" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1649989526_whatsapp.png" target="_blank" alt="img" style="width: 32px; margin-right: 6px; vertical-align: -7px" />WhatsApp </a>

              <a href="https://salesiq.zoho.com/signaturesupport.ls?widgetcode= 4604bc6e19540167f3028126486369708e09a24a7735e20a4832e664e2b81ba8" target="_blank"> <img class="lazy" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668497457_chat2.png" alt="img" target="_blank" style="width: 32px; margin-right: 6px; vertical-align: -10px" />{{ $t("index.Online") }} </a>
            </div>
          </div>
          <div class="inquiry-form overflow w50">
            <h2 class="inquiry-main-title text-capitalize wow fadeInUp">
              {{ $t("index.formTtile") }}
            </h2>
            <div class="sub-text wow fadeInUp" v-html="$t('index.formDept')"></div>
            <div action="https://inquiry.digoodcms.com/api/administrator" method="POST" class="index-form-validate py-5 row form-ade37d4caec88ab9644f918506e4d237 inquiry-message-form">
              <input name="page" type="hidden" value="" />
              <input id="backpage" name="backpage" type="hidden" value="" />

              <div class="form-group">
                <input type="text" v-model="modalParameter.userName" id="name" name="contact[fullname]" class="form-control1" :placeholder="$t('index.formName') + '*'" required />
              </div>
              <div class="form-group">
                <input type="email" v-model="modalParameter.userEmail" id="email" name="email" class="form-control1" :placeholder="$t('index.formEmail') + '*'" required pattern="[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?" />
              </div>
              <div class="form-group">
                <input type="text" v-model="modalParameter.userPhone" id="phone" name="contact[tel]" class="form-control1" :placeholder="$t('index.formTel')" pattern="(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$" />
              </div>
              <div class="form-group message-group">
                <textarea id="message" v-model="modalParameter.context" name="message" class="form-control1" :placeholder="$t('index.FormMsg') + '*'" required></textarea>
              </div>
              <div class="form-group1">
                <button @click='submit' class="submit-btn trans-dot5s text-capitalize" type="submit">{{ $t("index.formBtn") }}→</button>
              </div>
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_ipAddress" name="custom[ipAddress]" type="hidden" value="" />
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_countryName" name="custom[countryName]" type="hidden" value="" />
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_regionName" name="custom[regionName]" type="hidden" value="" />
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_cityName" name="custom[cityName]" type="hidden" value="" />
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_countryCode" name="custom[countryCode]" type="hidden" value="" />
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_zipCode" name="custom[zipCode]" type="hidden" value="" />
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_latitude" name="custom[latitude]" type="hidden" value="" />
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_longitude" name="custom[longitude]" type="hidden" value="" />
              <input class="custom-af1d1f4ff867a1499bd772c371f6936a_timeZone" name="custom[timeZone]" type="hidden" value="" />

              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_ipAddress" name="geoip[ipAddress]" type="hidden" value="" />
              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_countryName" name="geoip[countryName]" type="hidden" value="" />
              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_countryCode" name="geoip[countryCode]" type="hidden" value="" />
              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_regionName" name="geoip[regionName]" type="hidden" value="" />
              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_cityName" name="geoip[cityName]" type="hidden" value="" />
              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_zipCode" name="geoip[zipCode]" type="hidden" value="" />
              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_latitude" name="geoip[latitude]" type="hidden" value="" />
              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_longitude" name="geoip[longitude]" type="hidden" value="" />
              <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_timeZone" name="geoip[timeZone]" type="hidden" value="" />
              <input name="useragent[browser]" type="hidden" value="Chrome[86.0.4240.75]" />
              <input name="useragent[platform]" type="hidden" value="Windows 10" />
              <input name="useragent[lang]" type="hidden" value="zh-CN,zh;q=0.9,ja;q=0.8,en-US;q=0.7,en;q=0.6,zh-TW;q=0.5" />
              <input name="useragent[mobile]" type="hidden" value="No" />
              <input name="useragent[agent_string]" type="hidden" value="Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.75 Safari/537.36" />
            </div>
            <div class="inquiry_img hidden-xs">
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667550306_1.png" alt="img" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Certification Authority -->
    <section class="index-certification-part overflow">
      <div class="certification-bg lazy bg-cover" data-original="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668478381_11.jpg">
        <div class="container">
          <h2 class="home-main-title wow fadeInUp text-center white">
            {{ $t("index.cerTitle") }}
          </h2>
          <div class="home-sub-title relative wow fadeInUp text-center text-capitalize">
            <i class="title-line title-line1"></i>
            <span> {{ $t("index.creCen") }}</span>
            <i class="title-line title-line2"></i>
          </div>
          <div class="default-link-box text-center fontSize wow fadeInUp">
            <router-link class="text-capitalize default-link" to="/Certificates">{{ $t("index.creBtn") }}→</router-link>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="certificate-carousel owl-carousel owl-theme index-carousel">
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901400_FCC.png" alt="FCC" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">FCC</span>
          </div>
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901184_Design-Patent.jpg" alt="Design Patent" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">{{ $t("index.fccright") }}</span>
          </div>
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901156_CE.jpg" alt="CE" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">CE</span>
          </div>
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901125_CCC.png" alt="CCC" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">CCC</span>
          </div>
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901068_CB.png" alt="CB" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">CB</span>
          </div>
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667901028_BIS.png" alt="BIS" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">BIS</span>
          </div>
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667900988_ISO-9001.jpg" alt="ISO 9001" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">ISO 9001</span>
          </div>
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667900926_UN38.3.png" alt="UN38.3" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">UN38.3</span>
          </div>
          <div class="certificate-item">
            <div class="relative">
              <img class="certificate-bg1" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1668389566_2.png" alt="img" />
              <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/home/image_1667900800_Material-Safety-Data-Sheet.png" alt="Material Safety Data Sheet" style="position: relative; z-index: 4" />
            </div>
            <span class="certificate-title">{{ $t("index.fccleft") }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Latest News -->
    <section class="index-blog-part overflow">
      <div class="container">
        <h2 class="home-main-title wow fadeInUp text-center">
          {{ $t("index.laTtitle") }}
        </h2>
        <div class="home-sub-title relative wow fadeInUp text-center text-capitalize">
          <i class="title-line title-line1"></i>
          <span>
            {{ $t("index.laSubTtile") }}
          </span>
          <i class="title-line title-line2"></i>
        </div>
        <div class="row blog-list d-flex">
          <div class="col-md-4 col-sm-6 col-xs-12 blog-item-box wow fadeInUp" v-for="(item, index) in laList" :key="index">
            <div class="blog-item" style="height: 100%">
              <div class="blog-img relative">
                <a :href="'/Articles/' + item.trainingId" :title="item.title" class="img-block">
                  <img :src="item.cover" :alt="item.title" />
                </a>
                <div class="blog-data">
                  <span>{{ item.dateNum }}</span
                  >{{ item.dateTxt }}
                </div>
              </div>
              <h3 class="blog-title">
                <a :href="'/Articles/' + item.trainingId" :title="item.title" style="display: block">{{ $t(`index.title${index + 1}`) }}</a>
              </h3>
              <div class="blog-desc clamp clamp3">
                {{ $t(`index.content${index + 1}`) }}
              </div>
              <div class="read-more">
                <a :href="'/Articles/' + item.trainingId">{{ $t("index.ltBtns") }}→</a>
              </div>
            </div>
          </div>
        </div>
        <div class="default-link-box fontSize wow fadeInUp text-center" style="padding-top: 20px">
          <a href="https://zcmpsub.maillist-manage.com/ua/Optin?od=11287ecbcf7dfb&zx=12dbb92e1&sD=1c6b0bde3735056d" target="_blank" class="default-link text-capitalize">{{ $t("index.ltBtn") }}→</a>
        </div>
      </div>
    </section>

    <div style="position: fixed; top: 30%; left: 30%; right: 30%; z-index:1 ; text-align: center;" class="alert alert-danger" v-if="show" role="alert">{{ show }}</div>
<div style="position: fixed; top: 30%; left: 40%; right: 40%; padding: 20px 0; z-index: 1; text-align: center;" class="alert-success" v-if="successShow" role="alert">
<span class="glyphicon glyphicon-ok"></span>
</div>

  </div>
</template>

<script setup>


import { onMounted, watch } from "vue"

import router from "@/router/index"


import { reactive,getCurrentInstance ,ref} from 'vue';
import {saveConcat} from '@/utils/api.js'
const { proxy } = getCurrentInstance()
let modalParameter = reactive({
  userName:'',
  userEmail:'',
  context:'',
  userPhone:''
})

let show = ref(false);
let  successShow = ref(false);

let submit = ()=>{
  if(  successShow.value){
    return
  }
  show.value = false;
  for(let i in modalParameter){
    if(i!='userPhone' && !modalParameter[i]){
     show.value = i == 'userName'?'fullName':i=='userEmail'?'usEmail':i=='context'?'message':'';
    }
  }
  if(show.value){
    // alert(proxy.$t('contact.'+show))
   show.value = proxy.$t('contact.'+show.value);

   setTimeout(() => {
    show.value = false;
   }, 3000);
    return
  }

  saveConcat(modalParameter).then(res=>{
    if(res.code =='000000'){
      for(let i in modalParameter){
       modalParameter[i] = '';
  }
 successShow.value = true;
  setTimeout(() => {
    successShow.value = false;
  }, 3000);
    }
  })
}



import i18n from "@/i18n"
let info = reactive({
  list: [],
  shopList: [],
  type: "",
  show: true,
  laList: [
    {
      img: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1666408409_3.jpg",
      dateNum: "26",
      id: 1,
      dateTxt: "May",
      title: `2023中国国际自行车展览会`,
      content: `2023年5月5日，第31届中国国际自行车展览会
      于上海新国际博览中心举行`
    },
    {
      img: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1681710506_微信图片_20230411091737.jpg",
      dateNum: "17",
      id: 4,
      dateTxt: "Apr",
      title: `MIDONKEY电动自行车团队参加环球资源消费电子展`,
      content: `时间：2023-04-11-04-14 地址：香港亚洲国际博览馆 展位号：2j01`
    },
    {
      img: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1679390029_2.jpg",
      dateNum: "21",
      id: 2,
      dateTxt: "Mar",
      title: "MIDONKEY电动自行车实验室",
      content: `MIDONKEY电动自行车公司致力于提供
      为客户提供最优质的电动自行车。`
    }
  ],
  ft1: "成立专门的研发部",
  fimg1: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900477_Ebike-Design-Department.png",

  ft2: "电动自行车组装车间",
  fimg2: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900273_Ebike-Assembly-Line-2.jpg",

  ft3: "电动自行车组装车间",
  fimg3: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900312_Ebike-Assembly-Line.jpg",

  ft4: "自行车车轮装配区",
  fimg4: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900183_Bike-Wheel-Assembly-Area.jpg",

  ft5: "电动自行车材料准备区域",
  fimg5: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900506_Ebike-Materials-Preparation-Area.jpg",

  ft6: "电动自行车组装",
  fimg6: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900233_Ebike-Assembling.JPG",

  ft7: "电动自行车半成品区",
  fimg7: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900654_Semi-finished-Ebikes.jpg",

  ft8: "电动自行车测试区",
  fimg8: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900603_Ebike-Testing-Area.jpg",

  ft9: "电动自行车包装区",
  fimg9: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900540_Ebike-Packing-Area-2.png",

  ft10: "电动自行车包装区",
  fimg10: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900569_Ebike-Packing-Area.png",

  ft11: "电动自行车仓库",
  fimg11: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900727_Warehouse.jpg",

  ft12: "电动自行车大货运输",
  fimg12: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900452_Ebike-Bulk-Shipment.jpg",

  ft13: "盐雾实验室",
  fimg13: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900628_Salt-Spray-Test-Room.JPG",

  ft14: "电动自行车电池生产线",
  fimg14: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900395_Ebike-Battery-Assembly-Line.jpg",

  ft15: "电动自行车电池老化区",
  fimg15: "https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900114_Battery-Aging-Test.jpg"
})

import { pageIndependentProduct ,pagepageIndependentArticalInfo} from "@/utils/api"

const page = reactive({ page: 1, per_page: 3 })
const types = ref(2)
const title = ref('')
const laList= ref([])
const getLabList = () => {
  pagepageIndependentArticalInfo({ page, type: types.value, title: title.value, language: i18n.locale , state:1}).then((res) => {
    laList.value = res.data.list
  })

}

getLabList()
const loading = ref(true)

const getList = async () => {
  loading.value = true
  await pageIndependentProduct({ page: { page: 1, per_page: 10 }, language: i18n.locale, productType: info.type }).then((res) => {
    info.list = res.data.list
  })
  loading.value = false

  setTimeout(() => {
    if ($(".product-carousel1").length) {
      $(".product-carousel1").owlCarousel({
        loop: false,
        margin: 0,
        nav: true,
        dots: true,
        smartSpeed: 500,
        autoplay: 5000,
        rtl: document.querySelector("html").getAttribute("dir") === "rtl",
        navText: ['<svg class="icon"><use xlink:href="#arrow-right"></use></svg>', '<svg class="icon"><use xlink:href="#arrow-right"></use></svg>'],
        responsive: {
          0: {
            items: 1,
            margin: 15
          },
          600: {
            items: 2,
            margin: 15
          },
          992: {
            items: 3,
            margin: 15
          },
          1200: {
            items: 4,
            margin: 15
          }
        }
      })
    }
  }, 300)
}

let langFn = () => {
  getList()
}

langFn()
watch(
  () => i18n.locale,
  (currentValue, prevValue) => {
    langFn()
  }
)
let typeChange = (e) => {
  info.type = e
  getList()
}
let toDetail = (item) => {
  router.push({
    path: "/ProductDetail",
    query: {
      id: item.id,
      productId: item.productId,
    }
  })
}
onMounted(() => {
  // 首页代码
  // Banner
  if ($(".home-slider-banner").length) {
    $(".home-slider-banner").owlCarousel({
      items: 1,
      loop: true,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 6000,
      autoplayHoverPause: true,
      mouseDrag: false,
      lazyLoad: true,
      rtl: document.querySelector("html").getAttribute("dir") === "rtl"
    })
  }

  //Certificate Carousel1
  if ($(".certificate-carousel").length) {
    $(".certificate-carousel").owlCarousel({
      loop: true,
      margin: 0,
      nav: true,
      dots: false,
      smartSpeed: 500,
      autoplay: 5000,
      navText: ['<svg class="icon"><use xlink:href="#arrow-right"></use></svg>', '<svg class="icon"><use xlink:href="#arrow-right"></use></svg>'],
      rtl: document.querySelector("html").getAttribute("dir") === "rtl",
      responsive: {
        0: {
          items: 2,
          margin: 10
        },
        600: {
          items: 2,
          margin: 15
        },
        992: {
          items: 3,
          margin: 20
        },
        1200: {
          items: 4,
          margin: 30
        }
      }
    })
  }

  //CaseCarousel
  if ($(".case-carousel").length) {
    $(".case-carousel").owlCarousel({
      items: 1,
      loop: true,
      nav: true,
      dots: false,
      autoplay: false,
      autoplayTimeout: 6000,
      autoplayHoverPause: true,
      lazyLoad: true,
      center: true,
      navText: ['<svg class="icon"><use xlink:href="#arrow-right"></use></svg>', '<svg class="icon"><use xlink:href="#arrow-right"></use></svg>'],
      rtl: document.querySelector("html").getAttribute("dir") === "rtl",
      responsive: {
        0: {
          items: 1,
          margin: 10
        },
        600: {
          items: 2,
          margin: 15
        },
        992: {
          items: 2,
          margin: 20
        },
        1200: {
          items: 2,
          margin: 45
        }
      }
    })
  }
})
</script>

<style scoped>
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.home-slider-banner .mobile-banner {
  display: none;
}

.home-slider-banner .single-slider .container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.home-slider-banner .content {
  position: relative;
  padding: 70px 0;
  max-width: 970px;
  margin: 0 auto;
  opacity: 0;
}

.home-slider-banner .intro {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 15px;
}

.home-slider-banner .text {
  font-size: 16px;
  color: #fff;
  margin-top: 30px;
}

.home-slider-banner .banner-more-button a {
  border-radius: 21px;
  font-size: 16px;
  background-color: var(--main-theme-color);
  padding: 6px 26px;
  display: inline-block;
  line-height: inherit;
  transition: 0.5s;
  color: #fff !important;
}

.home-slider-banner .banner-more-button a:hover {
  transform: translateX(10px);
}

.home-slider-banner .owl-item.active .intro {
  -webkit-animation-delay: 0.7s;
  animation-delay: 0.7s;
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

.home-slider-banner .owl-item.active .text {
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

.home-slider-banner .owl-item.active .banner-more-button {
  -webkit-animation-delay: 0.9s;
  animation-delay: 0.9s;
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

.home-slider-banner .owl-item.active .content {
  opacity: 1;
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}

.index-products-part .filter-tabs {
  white-space: nowrap;
  overflow-x: auto;
}

.index-products-part .filter-tabs::-webkit-scrollbar-button {
  display: none;
}

.index-products-part .filter-tabs::-webkit-scrollbar {
  height: 6px;
}

.index-products-part .filter-tabs::-webkit-scrollbar-track {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.2);
}

.index-products-part .filter-tabs::-webkit-scrollbar-thumb {
  background: var(--main-theme-color);
  border-radius: 10px;
}

.index-certification-part .certificate-item {
  padding: 0 0px 0 30px;
}

.index-certification-part .certificate-bg1 {
  position: absolute;
  left: -42px;
  bottom: 0px;
}

@media (max-width: 1199px) {
  .home-slider-banner .intro {
    font-size: 37px;
  }
}

@media (max-width: 991px) {
  .home-slider-banner .intro {
    font-size: 32px;
  }

  .index-certification-part .certificate-bg1 {
    left: -50px;
  }
}

@media (max-width: 767px) {
  .home-slider-banner .intro {
    font-size: 17px;
    margin: 0 0 10px;
  }

  .home-slider-banner .banner-more-button a {
    font-size: 13px;
    padding: 3px 18px;
    line-height: 18px;
  }

  .index-certification-part .certificate-item {
    padding: 0 0 0 10px;
  }

  .index-certification-part .certificate-bg1 {
    left: -22px;
  }
}
</style>
